(()=>{
    document.addEventListener( "focus", (event)=>{
        let element = event.target;
        if(element.closest('.customer.register') != null && element.closest('.customer.register') != undefined){
            let type = event.target.type;
            if(type == "text" || type == "number" || type == "email"){
                element.closest(".cf-field").classList.add('field--show-floating-label');
            }
        }
    }, true);

    document.addEventListener( "focusout", (event)=>{
        let element = event.target;
        if(element.closest('.customer.register') != null && element.closest('.customer.register') != undefined){
            let type = event.target.type;
            if((type == "text" || type == "number" || type == "email") && (element.value == '' || element.value == null)){
                element.closest(".cf-field").classList.remove('field--show-floating-label');
                if(type == "text" && element.closest('.cf-phone-field') != null && element.value == '+1 '){
                    element.value = '';
                    element.closest(".cf-field").classList.remove('field--show-floating-label');
                }
            }else if(element.closest('.cf-phone-field') != null && element.value == '+1 '){
                element.value = '';
                element.closest(".cf-field").classList.remove('field--show-floating-label');
            }
        }
    }, true);
})();